import React from "react";
import { Modal } from "@components";
import { useNavigate } from "react-router-dom";

/**
 * Where identity validation starts: the FEA enrolment for a doctor who has
 * none, and the validation with the new signing provider for one who signs
 * already. The enrolment orchestrator picks the flow.
 */
export const IDENTITY_VALIDATION_ROUTE =
  "/app/registro/firma-electronica-avanzada/validation-challenge";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  secondaryButtonText?: string;
  onSecondaryAction?: () => void;
}

/**
 * A doctor moving to the new signing provider whose deadline to validate their
 * identity passed: they create no document, whatever its signature, until
 * they validate. Shown before a document starts and, if the signing endpoint
 * rejects them, on the signing screen, with the same words.
 */
export const ValidationRequiredModal: React.FC<Props> = ({
  isOpen,
  onClose,
  secondaryButtonText = "Volver",
  onSecondaryAction,
}) => {
  const navigate = useNavigate();

  return (
    <Modal
      title="Valida tu identidad para seguir firmando"
      content="Estamos actualizando tu firma electrónica avanzada y necesitamos que valides tu identidad para volver a emitir documentos. Seguirás usando el mismo PIN."
      isOpen={isOpen}
      onClose={onClose}
      buttonProps={{
        buttonText: "Validar identidad",
        onClick: () => navigate(IDENTITY_VALIDATION_ROUTE),
      }}
      secondaryButtonProps={{
        buttonText: secondaryButtonText,
        onClick: onSecondaryAction ?? onClose,
      }}
    />
  );
};
